import ApiHelper from "@/services/Infrastructure/ApiHelper";
import { v4 as uuidv4 } from "uuid";
import { RecentCardsHelper } from "@/core/helpers/RecentCardsHelper";

export class GaHelper {
    private static widgetId: string;
    static userId: string;

    static send(name: string) {
        const logUrl = ApiHelper.baseURL + "/log";
        const pagePath = "/" + name;
        fetch(logUrl + "/view", {
            method: "POST",
            body: JSON.stringify({
                userId: this.userId,
                widgetId: GaHelper.widgetId,
                pagePath: pagePath,
            }),
            headers: { "Content-Type": "application/json" },
        });
    }

    static Init(id: string) {
        this.widgetId = id;
        let userId = uuidv4();
        if (RecentCardsHelper.isLocalStorageAccessible()) {
            const savedId = window.localStorage.getItem("gaUserId");
            if (savedId) userId = savedId;
            window.localStorage.setItem("gaUserId", userId);
        }
        this.userId = userId;
    }
}
